type AdminHeaderProps = {
  title: string;
  description?: string;
  action?: React.ReactNode;
};

export function AdminHeader({ title, description, action }: AdminHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-4">
          <h1 className="font-semibold text-lg">{title}</h1>
          {description && <p className="text-muted-foreground text-sm">{description}</p>}
        </div>
      </div>
      {action && <div className="flex items-center gap-2">{action}</div>}
    </div>
  );
}
